import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VMenu,
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    VBtn,
                    _vm._g(
                      {
                        staticClass: "ml-2",
                        attrs: {
                          small: "",
                          color: "primary",
                          disabled: _vm.disabled,
                          loading: _vm.loading,
                          depressed: "",
                        },
                      },
                      on
                    ),
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("workPackages.exportToSAP.title")) +
                          "\n        "
                      ),
                      _c(VIcon, [_vm._v("mdi-chevron-down")]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            VList,
            [
              _c(
                VListItem,
                { on: { click: _vm.handleExportFile } },
                [
                  _c(VListItemTitle, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("workPackages.exportToSAP.downloadFile")
                        ) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VListItem,
                { on: { click: _vm.handleDownstreamExport } },
                [
                  _c(VListItemTitle, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("workPackages.exportToSAP.exportToSystem")
                        ) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("alert-dialog", {
        attrs: {
          "is-open": _vm.isDownstreamExportDialogOpen,
          "ok-btn-text": _vm.$t("actions.confirm"),
          "disable-ok-button": !_vm.isExportEligible,
        },
        on: {
          onOk: _vm.confirmDownstreamExport,
          onCancel: _vm.closeDownstreamExportDialog,
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _vm._v(
                  _vm._s(_vm.$t("dialogs.exportToDownstreamSystem.header"))
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "p",
                  {
                    staticClass: "dialog-warning",
                    attrs: { id: "downstream-export-warning" },
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("dialogs.exportToDownstreamSystem.warning")
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("p", [
                  _vm.formattedBodyText.plain
                    ? _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formattedBodyText.plain) +
                            "\n          "
                        ),
                        _vm.formattedBodyText.bold
                          ? _c("strong", [
                              _vm._v(_vm._s(_vm.formattedBodyText.bold)),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                !_vm.isExportEligible
                  ? _c(VAlert, { attrs: { type: "error", outlined: "" } }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("workPackages.noApprovedPricingGroups")
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }